import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function UserCircle({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>UserCircle</title>
      <path
        d="M16.9696 19.5047L17.3843 20.1296L16.9696 19.5047ZM7.03036 19.5047L6.6157 20.1296L7.03036 19.5047ZM11 16.75H13V15.25H11V16.75ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75V2.25C6.61522 2.25 2.25 6.61522 2.25 12H3.75ZM12 3.75C16.5563 3.75 20.25 7.44365 20.25 12H21.75C21.75 6.61522 17.3848 2.25 12 2.25V3.75ZM14.25 10C14.25 11.2426 13.2426 12.25 12 12.25V13.75C14.0711 13.75 15.75 12.0711 15.75 10H14.25ZM12 12.25C10.7574 12.25 9.75 11.2426 9.75 10H8.25C8.25 12.0711 9.92893 13.75 12 13.75V12.25ZM9.75 10C9.75 8.75736 10.7574 7.75 12 7.75V6.25C9.92893 6.25 8.25 7.92893 8.25 10H9.75ZM12 7.75C13.2426 7.75 14.25 8.75736 14.25 10H15.75C15.75 7.92893 14.0711 6.25 12 6.25V7.75ZM13 16.75C14.6581 16.75 16.0272 17.9924 16.2253 19.5966L17.714 19.4128C17.4242 17.0662 15.4248 15.25 13 15.25V16.75ZM20.25 12C20.25 14.8716 18.7834 17.4011 16.555 18.8797L17.3843 20.1296C20.0138 18.3849 21.75 15.3953 21.75 12H20.25ZM16.555 18.8797C15.25 19.7456 13.6851 20.25 12 20.25V21.75C13.9891 21.75 15.8411 21.1536 17.3843 20.1296L16.555 18.8797ZM7.77471 19.5966C7.97284 17.9924 9.3419 16.75 11 16.75V15.25C8.57525 15.25 6.57582 17.0662 6.28602 19.4128L7.77471 19.5966ZM12 20.25C10.3149 20.25 8.74997 19.7456 7.44503 18.8797L6.6157 20.1296C8.15886 21.1536 10.0109 21.75 12 21.75V20.25ZM7.44503 18.8797C5.21655 17.4011 3.75 14.8716 3.75 12H2.25C2.25 15.3953 3.98618 18.3849 6.6157 20.1296L7.44503 18.8797Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
